module.exports = __webpack_public_path__ + "media/images/symbol-defs-1b657824f23c921a81b5594725ec5df5.svg";